<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    viewBox="0 0 129.24 108.05"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="vowchat-gradient-1"
        x1="127.28"
        y1="-45.7"
        x2="-33.11"
        y2="60.86"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#6313ff" />
        <stop offset="1" stop-color="#3a198a" />
      </linearGradient>
      <linearGradient
        id="vowchat-gradient-2"
        x1="159.35"
        y1="2.17"
        x2="-1.09"
        y2="108.76"
        href="#vowchat-gradient-1"
      />
      <linearGradient
        id="vowchat-gradient-3"
        x1="136.08"
        y1="-32.52"
        x2="-24.31"
        y2="74.03"
        href="#vowchat-gradient-1"
      />
      <linearGradient
        id="vowchat-gradient-4"
        x1="168.46"
        y1="16.14"
        x2="8.42"
        y2="122.45"
        href="#vowchat-gradient-1"
      />
    </defs>
    <g>
      <path
        d="M17.44,32.89c2.42-4.48,5.72-8.42,9.66-11.6,.45-.36,.91-.72,1.37-1.06,1.95-1.44,4.05-2.7,6.27-3.76,2.39-1.15,4.95-2.05,7.59-2.68,1.58-.39,3.21-.67,4.86-.85,1.37-.16,2.78-.23,4.21-.23,1.34,0,2.67,.07,3.98,.2l1.21-4.48,2.13-7.9C56.41,.21,54.07,.02,51.69,.01h-.01c-.16-.01-.31-.01-.47-.01-1.77,0-3.52,.09-5.24,.27l-.09,.33-.03-.32c-4.36,.44-8.55,1.43-12.51,2.88-.51,.19-1.01,.37-1.5,.58C23.19,7.23,15.72,12.96,10.15,20.23c-2.94,3.83-5.34,8.09-7.1,12.66-1.52,3.93-2.55,8.07-3.05,12.39H13.28c.67-4.42,2.09-8.6,4.15-12.39Z"
        fill="url(#vowchat-gradient-1)"
      />
      <path
        d="M78,48.58l-20.37,35.57-3.5-35.57h-15.97l4.99,46.81h-15.23c-.2,.03-.42,.04-.62,.04s-.42-.01-.61-.04c-2.7-.3-4.79-2.57-4.79-5.33,0-.29,.02-.58,.08-.85,.04-.39,.16-.78,.3-1.14l2.53-9.4,1.04-3.86,1.14-4.18,4.2-15.57h-13.2l-2.58,9.58-4.85,17.99-.99,3.64-.44,1.64c-.02,.06-.03,.11-.04,.17-.23,1.09-.34,2.21-.34,3.36,0,1.35,.17,2.68,.48,3.94,1.11,4.58,4.14,8.42,8.21,10.65,2.11,1.16,4.51,1.87,7.06,2.02h2.01c1.16-.06,3.21,0,3.21,0h27.56s3.87,0,3.87,0c.54,0,1.14-.3,1.79-.9,.65-.6,1.3-1.29,1.96-2.08,.65-.79,1.23-1.57,1.75-2.36,.52-.79,.91-1.4,1.18-1.85l29.17-52.29h-18.98Z"
        fill="url(#vowchat-gradient-2)"
      />
      <path
        d="M53.39,20.31c-.72-.06-1.45-.08-2.18-.08-1.09,0-2.16,.05-3.23,.17-2.78,.28-5.44,.93-7.95,1.89-1.55,.58-3.04,1.29-4.46,2.11-3.74,2.16-6.98,5.05-9.52,8.5-1.77,2.4-3.21,5.05-4.22,7.91l-1.22,4.49h13.29c.72-2.14,1.83-4.1,3.26-5.8,2.96-3.56,7.27-5.97,12.14-6.49v-.1s.67,0,.67,0l3.4-12.58Z"
        fill="url(#vowchat-gradient-3)"
      />
      <path
        d="M121.88,95.39l-11.4-19.6,5.59-20.71,2.64-9.8s.37-1.73,.72-2.66h0s.83-3.08,.83-3.08h0c.16-.91,.24-1.83,.24-2.77,0-1.33-.16-2.64-.47-3.89-1.11-4.63-4.17-8.51-8.29-10.72-.95-.52-1.96-.95-3.02-1.27-1.08-.33-2.22-.56-3.39-.67H63.15l-.58,2.13-2.84,10.53h27.47l.54-.93c-.09,.3-.18,.62-.25,.93h13.63c.26-.05,.52-.07,.79-.07h.02c.28,0,.55,.02,.82,.07,2.58,.38,4.56,2.59,4.56,5.27,0,.21-.01,.41-.04,.61-.05,.54-.2,1.04-.41,1.52,0,.01-.01,.01-.01,.02l-1.34,4.97-2.19,8.09-.46,1.71-.41,1.51h0s-1,3.7-1,3.7l-3.16,11.74h0s-.01,.02-.01,.03l-1.29,4.78-.2,.74,8.86,15.25h0s.16,.26,.16,.26l1.34,2.3h-15.17l-3.41,12.66h40.66l-7.36-12.66Z"
        fill="url(#vowchat-gradient-4)"
      />
    </g>
  </svg>
</template>
